import { Theme } from "apps/website/maps/Theme.map";

import type { FlowPage, PageRequirement } from "../../shared/constants";
import type { TDirectSalesViewState } from "@./suf-store";

// Sign-up flow store TTL: local store gets cleared after this many days of inactivity
export const DIRECT_SALES_FLOW_TTL_DAYS = 30; // @TODO: to what? an hour?

export enum DirectSalesFlowSlug {
  // BA authentication page
  AMBASSADOR = "/sign-up/direct/ambassador",

  // Cat pages
  CAT_COUNT = "/sign-up/direct/fresh",
  CAT_DETAILS = "/sign-up/direct/fresh/cat-details",

  // User pages
  CHECKOUT = "/sign-up/direct/fresh/checkout",

  // Pages with no validation
  RECIPES = "/sign-up/direct/fresh/recipes",
  SUCCESS = "/sign-up/direct/fresh/success",
}

export const defaultDirectSalesViewState: TDirectSalesViewState = {
  checkout: {
    // Delivery/Shipping Address Section
    showManualEntryButton: true,
    showAddressSelect: false,
    showShippingAddressFields: false,
    hasClickedFindAddress: false,
    hasSelectedAddressFromLookup: false,
    showShippingAddressWarning: false,
    showBillingAddressFields: false,
    billingSameAsShipping: true,
    showProcessingModal: false,
    shouldTriggerPayment: false,
    showTapToPayModal: false,
  },
  catDetails: {},
};

export interface IDirectSalesPageMetadata {
  title?: string
  hideProgressSteps?: boolean
  hideFooter?: boolean
  headerBgColor?: Theme
  bgColor?: Theme
  isUserPage?: boolean
  copyCatAnswers?: boolean
  hidePromoBanner?: boolean
  hideImage?: boolean
  hideQuoteBanner?: boolean
  promoBannerAnimateOnEntry?: boolean
  /**
   * Access requirements are used to determine if a page should be displayed to the user.
   * Example A/B test requirement
   * accessRequirements: [
        (context: FlowNavigationContext) => context.inABTestGroup("new-basic-information-flow"),
      ],
   */
  accessRequirements?: PageRequirement[]
}

const lightGrey = "light-grey";

export const DIRECT_SALES_FLOW_PAGES: Record<DirectSalesFlowSlug, IDirectSalesPageMetadata> = {
  [DirectSalesFlowSlug.AMBASSADOR]: {
    isUserPage: true,
    hideProgressSteps: true,
    hidePromoBanner: true,
    bgColor: "brand",
  },
  [DirectSalesFlowSlug.CAT_COUNT]: {
    title: "catCount",
    bgColor: lightGrey,
    promoBannerAnimateOnEntry: true,
    hideImage: false,
    hideQuoteBanner: false,
  },
  [DirectSalesFlowSlug.CAT_DETAILS]: {
    title: "catDetails",
    copyCatAnswers: false,
    hideImage: true,
  },
  [DirectSalesFlowSlug.RECIPES]: {
    title: "recipes",
    hidePromoBanner: true,
    hideImage: true,
  },
  [DirectSalesFlowSlug.CHECKOUT]: {
    title: "checkout",
    isUserPage: true,
    hidePromoBanner: true,
    hideImage: true,
  },
  [DirectSalesFlowSlug.SUCCESS]: {
    isUserPage: true,
    hideImage: true,
    hideProgressSteps: true,
    hidePromoBanner: true,
    bgColor: "light-grey",
    headerBgColor: "light",
  },
};

export const directSalesFlowPages: FlowPage<DirectSalesFlowSlug>[] = Object.entries(DIRECT_SALES_FLOW_PAGES).map(
  ([ slug, metadata ]) => ({
    slug: slug as DirectSalesFlowSlug,
    accessRequirements: metadata.accessRequirements ?? [],
  }),
);
